<template>
  <Posts :object="object" :params="params" :key="version" />
</template>

<script>
import {defineComponent, onMounted, ref} from "vue"
import Posts from "@/modules/post/pages/posts/components/posts/Posts"
import Promocode from "@/modules/post/pages/posts/services/Promocode"
import {useRoute} from "vue-router"

export default defineComponent({
  name: "Articles",
  components: {
    Posts
  },
  setup() {
    let version = ref(0)
    const route = useRoute()
    let object = new Promocode(
        route?.query?.shop_id,
    )

    let params = {
      title: "Все статьи",
      h1: "Статьи",
      page: "articles",
      type_ids: [15],
      channel_id: getChannelId(),
    }

    function getChannelId() {
      return 1
    }

    onMounted(() => {
      version.value++
    })

    return {
      object,
      params,
      version,
    }
  }
})
</script>
